export default __webpack_public_path__ + "static/media/bitnami.939973e9.svg";